<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <div v-if="isOutletSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!isOutletSpinnerShow && userOutletItems.length == 0">{{$t('table.no_records')}}</div>
                    <div v-if="!isOutletSpinnerShow && userOutletItems.length != 0">
                        <h6 class="mt-3 text-secondary fw-300">{{$t('user.header_sub_outlet', {'user': sTitle})}}</h6>
                        <b-table striped hover bordered :fields="fields" :items="userOutletItems" responsive>
                            <template #cell(index)="data">
                                {{ data.index + 1 }}
                            </template>
                            <template #cell(bizName)="data">
                                {{data.item.bizName == "" ? "-" : data.item.bizName}}
                            </template>
                            <template #cell(location)="data">
                                {{data.item.location == "" ? "-" : data.item.location}}
                            </template>
                            <template #cell(city)="data">
                                {{data.item.city == "" ? "-" : data.item.city}}
                            </template>
                            <template #cell(isEnable)="data">
                                <span  class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">
                                    {{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}
                                </span>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import tbl from '@/assets/js/dashboard/table-header.js'
import {handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: "userOutletList",
    data(){
        return{
            isOutletSpinnerShow: false,
            userOutletItems: [],
            sTitle: "", userID: 0,
            userOutletListTblHdr: tbl.userOutletListTblHdr,
        }
    },
    computed:{
        fields(){
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "username", label: this.$i18n.t('table.header.username'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "bizName", label: this.$i18n.t('table.header.bizName'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true},
                { key: "location", label: this.$i18n.t('table.header.location'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "city", label: this.$i18n.t('table.header.city'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "contact", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
            ]
        },
    },
    methods:{
        async getUserOutlet(id, title){
            this.userID = id
            this.sTitle = title
            this.isOutletSpinnerShow = true
            
            let $vm = this
            const url = $vm.$api.USER + "/" + id + $vm.$api.USER_OUTLET
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.isOutletSpinnerShow = false
            this.userOutletItems = result
            this.$emit('setUserOutlet', result)
        },
    }
}
</script>